import {
    Advisor, AdvisorUI,
    AdvisorWebDesignPlugin, QuestionType,
} from "@zoovu/runner-browser-api";
import {scrollToElement} from "../../components/utils";
import {isScrollingDisabledThroughDataAttribute} from "../data-attributes-reader/webdesign-context";
import {AnswersConfiguration} from "../../configuration";

export class AutoForwardPlugin implements AdvisorWebDesignPlugin {
    private advisor: Advisor;
    private advisorUi: AdvisorUI;
    private answersConfiguration: AnswersConfiguration;

    public async beforeMount(advisor: Advisor): Promise<void> {
        this.advisor = advisor;
    }

    public async afterMount(advisorUi: AdvisorUI): Promise<void> {
        this.advisorUi = advisorUi;

        const componentsConfiguration = this.advisorUi.getAdvisorRootView()["componentsConfiguration"];

        this.answersConfiguration = componentsConfiguration && componentsConfiguration.answersConfiguration;

        this.advisor.onGlobalEvent("AnswerModel.select:beforeActionSession", (event) => {
            const eventSource = event.eventSource;
            const newAnsweredQuestionType = eventSource.questionType;

            if (newAnsweredQuestionType !== QuestionType.RADIO || !this.isEnabled) return;
            if (eventSource.selected) {
                this.advisorGoNext();
                return;
            }

            this.advisor.onGlobalEventOnce("QAFlowModel.setNewSpecification:after", () => {
                const currentFlowStep = this.advisor.flowStepsNavigation.currentFlowStep;
                if (currentFlowStep.questions.length === 1) {
                    this.advisorGoNext();
                }
            });
        });
    }

    public get isEnabled(): boolean {
        return this.answersConfiguration && this.answersConfiguration.automaticForwarding !== null ?
            this.answersConfiguration.automaticForwarding : true;
    }

    private async advisorGoNext(): Promise<void> {
        const root = this.advisorUi.getAdvisorRootView().$el;

        this.advisor.advisorNavigation.next();

        await this.advisorUi.getAdvisorRootView().$nextTick();

        if (!isScrollingDisabledThroughDataAttribute && this.answersConfiguration.scrollToTop) {
            scrollToElement(root);
        }
    }
}
